import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPackagesList } from "../../services/packagesApi";
import DiscountCodeModal from "../../components/Purchase/DiscountCodeModal";
import OrderSummaryModal from "../../components/Purchase/OrderSummaryModal";
import "./SubscriptionPage.css";

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [discountData, setDiscountData] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await getPackagesList();

      if (response?.success && response?.data?.data) {
        const activePackages = response.data.data
          .filter((pkg) => pkg.packageId.status === true)
          .sort((a, b) => a.positionPakcage - b.positionPakcage);

        setPackages(activePackages);
      } else {
        setError("خطا در دریافت لیست پکیج‌ها");
      }
    } catch (err) {
      setError("خطا در ارتباط با سرور");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price, unit) => {
    const toman = price / 10;

    switch (unit) {
      case "thousandTomans":
        return `${(toman / 1000).toFixed(0)} هزار تومان`;
      case "millionTomans":
        return `${(toman / 1000000).toFixed(1)} میلیون تومان`;
      default:
        return `${toman.toLocaleString()} تومان`;
    }
  };

  const handleSelectPackage = (pkg) => {
    setSelectedPackage(pkg);
    setShowDiscountModal(true);
  };

  const handleBackFromDiscount = () => {
    setShowDiscountModal(false);
    setSelectedPackage(null);
    setDiscountData(null);
  };

  const handleContinueFromDiscount = (data) => {
    setDiscountData(data);
    setShowDiscountModal(false);
    setShowOrderModal(true);
  };

  const handleBackFromOrder = () => {
    setShowOrderModal(false);
    setShowDiscountModal(true);
  };

  const handleCloseAll = () => {
    setShowDiscountModal(false);
    setShowOrderModal(false);
    setSelectedPackage(null);
    setDiscountData(null);
  };

  const handleUserInfoLoaded = (info) => {
    setUserInfo(info);
  };

  return (
    <div className="subscription-page">
      <header className="subscription-header">
        <button className="back-btn" onClick={() => navigate("/")}>
          ← بازگشت
        </button>
        <h1>خرید اشتراک</h1>
      </header>

      <main className="subscription-content">
        {loading && (
          <div className="subscription-loading">
            <div className="spinner"></div>
            <p>در حال دریافت لیست پکیج‌ها...</p>
          </div>
        )}

        {error && (
          <div className="subscription-error">
            <p>{error}</p>
            <button className="retry-btn" onClick={fetchPackages}>
              تلاش مجدد
            </button>
          </div>
        )}

        {!loading && !error && packages.length === 0 && (
          <div className="subscription-empty">
            <p>پکیجی برای نمایش وجود ندارد</p>
          </div>
        )}

        {!loading && !error && packages.length > 0 && (
          <div className="packages-grid">
            {packages.map((pkg) => (
              <div
                key={pkg.packageId._id}
                className={`package-card ${
                  pkg.typeOfPackage === "popular" ? "popular" : ""
                }`}
              >
                {pkg.typeOfPackage === "popular" && (
                  <div className="popular-badge">
                    {pkg.subDisplayName || "پرفروش‌ترین"}
                  </div>
                )}

                <div className="package-title">{pkg.packageId.displayName}</div>

                <div className="package-duration">
                  {pkg.packageId.validityDuration} روز
                </div>

                <div className="package-price">
                  {pkg.packageId.discountPercent > 0 && (
                    <>
                      <span className="old-price">
                        {formatPrice(
                          pkg.packageId.realPrice,
                          pkg.packageId.unitPriceDisplay,
                        )}
                      </span>
                      <span className="discount-badge">
                        -{pkg.packageId.discountPercent}%
                      </span>
                    </>
                  )}
                  <div className="final-price">
                    {formatPrice(
                      pkg.packageId.price,
                      pkg.packageId.unitPriceDisplay,
                    )}
                  </div>
                </div>

                <div className="package-features">
                  {pkg.packageId.features?.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      {feature}
                    </div>
                  ))}
                </div>

                <button
                  className="select-package-btn"
                  onClick={() => handleSelectPackage(pkg)}
                >
                  {pkg.buttonText || "انتخاب"}
                </button>
              </div>
            ))}
          </div>
        )}
      </main>

      {showDiscountModal && selectedPackage && (
        <DiscountCodeModal
          isOpen={showDiscountModal}
          onClose={handleCloseAll}
          onBack={handleBackFromDiscount}
          selectedPackage={selectedPackage}
          onContinue={handleContinueFromDiscount}
          onUserInfoLoaded={handleUserInfoLoaded}
        />
      )}

      {showOrderModal && selectedPackage && discountData && (
        <OrderSummaryModal
          isOpen={showOrderModal}
          onClose={handleCloseAll}
          onBack={handleBackFromOrder}
          selectedPackage={selectedPackage}
          discountData={discountData}
          userInfo={userInfo}
        />
      )}
    </div>
  );
};

export default SubscriptionPage;
